export default function BookClub() {
  return (
    <section id="book-club" className="bg-white text-black px-5 py-14 md:py-16">

      {/* Top label */}
      <div className="flex items-center justify-center gap-3 mb-6">
        <div className="h-px w-12 bg-[#D07728]/60" />
        <h3 className="text-sm uppercase tracking-wide text-[#D07728]">
          COMMUNITY THEOLOGY BOOK CLUB
        </h3>
        <div className="h-px w-12 bg-[#D07728]/60" />
      </div>

      {/* Content */}
      <div className="max-w-2xl mx-auto text-center">

        <h2 className="text-4xl md:text-5xl leading-tight mb-5">
          Read, <span className="text-[#D07728]">Reflect</span> &amp; Discuss
        </h2>

        <p className="text-gray-600 md:text-lg leading-relaxed mb-6">
          Join a book club exploring faith, mission, justice, and the
          world we share through thoughtful conversation and community.
        </p>

        <a
          href="https://www.stnicholasperivale.church/community-theology-book-club"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block border border-black px-3 py-2 md:px-4 text-xs md:text-sm whitespace-nowrap hover:bg-black hover:text-white transition"
        >
          EXPLORE THE BOOK CLUB <span className="text-[#D07728]">↗</span>   
        </a>

      </div>

    </section>
  );
}
